export enum QueryParams {
    username = 'username',
    userProfileId = 'userProfileId',
    password = 'password',
    token = 'token',
    locale = 'locale',
    type = 'type',
    regionId = 'regionId',
    countryCode = 'countryCode',
    classId = 'classId',
    groupId = 'groupId',
    dynamicParams = 'dynamicParams',
    userProfileType = 'userProfileType',
    marketRegionId = 'marketRegionId',
    isOneRosterActivatedSchool = 'isOneRosterActivatedSchool',
    schoolId = 'schoolId',
    oneRosterUserId = 'oneRosterUserId'
}

export enum CountryCodes {
    AUS = 'AUS',
    NZL = 'NZL'
}

export enum DynamicParams {
    conquestResultsEmptyStateNavigation = 'conquestResultsEmptyStateNavigation',
    zoomPromptShown = 'zoomPromptVisible',
	combinedAssignAndReviewDefaultTab = 'combinedAssignAndReviewDefaultTab',
    combinedAssignChallengesGridView = 'combinedAssignChallengesGridView',
    combinedAssignChallengesIconView = 'combinedAssignChallengesIconView'

}
